"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : FORM : FIELD : CHECKBOX : STYLES --------------- ++++++++++ */


var _default = {
  checkbox: {
    height: (0, _index.pxToEm)(18),
    width: (0, _index.pxToEm)(18),
    marginRight: (0, _index.pxToEm)(17),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: "".concat(_index.theme.color.primary.medium.contrast),
    borderRadius: (0, _index.pxToEm)(4),
    border: (0, _index.replacePXinStringWithEM)("1px solid ".concat(_index.theme.color.neutral.light.swatch)),
    transform: 'scale(1.6)',
    marginLeft: (0, _index.pxToEm)(7),
    // needed because of scale which pushes outside bounding box of parent
    transition: 'border .2s linear 0s',
    '&:hover': {
      borderColor: _index.theme.color.grey.medium.swatch
    },
    '& .check': {
      color: "".concat(_index.theme.color.primary.medium.contrast),
      transform: 'scale(.7)' // fontSize: pxToEm(8),

    },
    '&.checked': {
      background: "".concat(_index.theme.color.primary.medium.swatch),
      border: (0, _index.replacePXinStringWithEM)("2px solid ".concat(_index.theme.color.primary.medium.swatch))
    },
    '&.disabled': {
      cursor: 'auto',
      background: "".concat(_index.theme.color.neutral.medium.swatch, " !important"),
      border: (0, _index.replacePXinStringWithEM)("2px solid ".concat(_index.theme.color.neutral.medium.swatch, " !important"))
    }
  }
};
exports.default = _default;